import { render, staticRenderFns } from "./PurchaseGiftAccordion.vue?vue&type=template&id=26afac31&scoped=true&"
import script from "./PurchaseGiftAccordion.vue?vue&type=script&lang=js&"
export * from "./PurchaseGiftAccordion.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseGiftAccordion.vue?vue&type=style&index=0&id=26afac31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afac31",
  null
  
)

export default component.exports